import axios from 'axios';
import { getUser, removeUserSession, setUserSession } from '../component/Utils/Common';

import CryptoJS from 'crypto-js';

// getToken
//const API_URL = 'http://localhost:8080'


const API_username = 'javainuse';
const API_password = 'password';


class AuthenticationService {


    //later 
    executeJwtAuthenticationService() {
        const username = API_username;
        const password = API_password;
        var date = new Date();
        var mnth = '';
        var min = '';
        if ((date.getMonth() + 1) < 10) {
            mnth = '0' + (date.getMonth() + 1);
        } else {
            mnth = (date.getMonth() + 1);
        }
        var dte = '';
        if ((date.getDate()) < 10) {
            dte = '0' + (date.getDate());
        } else {
            dte = (date.getDate());
        }
        if (date.getMinutes() < 10) {
            min = '0' + date.getMinutes();
        } else {
            min = date.getMinutes()
        }
        var curDate = date.getFullYear() + '' + mnth + '' + dte + '' + date.getHours() + '' + min;
        const data = curDate;
        console.log("ddr " + data);
        const usernameencrypt = CryptoJS.AES.encrypt(username, "iyyapan").toString();
        const psswordecrypt = CryptoJS.AES.encrypt(password, "iyyapan").toString();
        const user_object = {
            username: usernameencrypt.toString(),
            password: psswordecrypt.toString()
        };
        // let user_object = {userName :API_username, password:API_password}
        console.log(user_object);
        return axios.post("http://35.154.221.117:8081/ngp_erp_stsV1/authenticate", user_object);
        // return axios.post("http://localhost:8080/ngp_erp_stsV1-0.0.1/authenticate",user_object);
        // return axios.post("http://localhost:8081/authenticate",user_object);
    }


    registerSuccessfulLoginForJwt(username, token) {

        setUserSession("Bearer " + token, username)

    }

    logout() {
        removeUserSession();
    }

    isUserLoggedIn() {
        let user = getUser();
        if (user === null) return false
        return true
    }

    getLoggedInUserName() {
        let user = getUser();
        if (user === null) return ''
        return user
    }


}

export default new AuthenticationService()